import api from './api';

import resources from "@core/Util/resources";
import {
    bootstrapDangerGrowl as errorGrowl, 
    bootstrapSuccessGrowl as successGrowl
} from "@core/Util/growler";

import loader from "@core/Util/loader";

/**
 * Validate and display whether the given operator scheme is valid or not
 * 
 * @param {String} schemeId Operator schemeId to validate
 * @param {Number} [revision] Revision to validate, when not provided `current` will be used
 * @return {Promise<void>} Promise resolving on completion of validation
 */
export const validateScheme = async (schemeId, revision) => {
    loader.showProgressCursor();
    
    try {
        await api.validateScheme(schemeId, revision);
        successGrowl(resources('Operator_ValidateScheme_SuccessMessage'));
    } catch(e) {
        errorGrowl(e);
    }
    
    loader.stopProgressCursor();
}; 